(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const targets = document.querySelectorAll('.flora .section, .flora .process, .flora .field, .flora .order');
  targets.forEach((el, index) => {
    el.classList.add('motion-section');
    el.style.setProperty('--motion-delay', `${Math.min(index * 55, 220)}ms`);
  });

  if (reduced) {
    targets.forEach((el) => el.classList.add('in-view'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.13 });
  targets.forEach((el) => observer.observe(el));

  const numbers = document.querySelectorAll('.metrics b');
  numbers.forEach((node) => {
    const text = node.textContent.trim();
    const match = text.match(/[\d.]+/);
    if (!match) return;
    const goal = Number(match[0].replace('.', ''));
    const suffix = text.replace(match[0], '');
    const isDecimal = match[0].includes('.');
    node.textContent = '0' + suffix;
    let started = false;
    const count = () => {
      if (started) return;
      started = true;
      const start = performance.now();
      const duration = 1100;
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = Math.round(goal * eased);
        node.textContent = (isDecimal ? (value / 10).toFixed(1) : value.toLocaleString('de-DE')) + suffix;
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) { count(); obs.disconnect(); }
    }, { threshold: 0.8 }).observe(node);
  });

  const hero = document.querySelector('.flora .hero');
  const tablet = document.querySelector('.flora .tablet');
  if (hero && tablet) {
    hero.addEventListener('pointermove', (event) => {
      if (window.innerWidth < 760) return;
      const x = (event.clientX / window.innerWidth - .5) * 8;
      const y = (event.clientY / window.innerHeight - .5) * 5;
      tablet.style.setProperty('--tilt-x', `${x}deg`);
      tablet.style.setProperty('--tilt-y', `${y}px`);
    });
    hero.addEventListener('pointerleave', () => {
      tablet.style.setProperty('--tilt-x', '0deg');
      tablet.style.setProperty('--tilt-y', '0px');
    });
  }
})();
